import React from "react";

export default () => (
  <div style={{ borderBottom: "1px solid #eee", margin: "1rem auto" }}></div>
);
